import React, { useMemo } from 'react';
import { useSimulationContext } from '../../providers/SimulationProvider';
import { AvatarLoader } from '../three/AvatarLoader';
import {
  buildCharacterClient,
  getMultiCharacterPosition,
  pairCharacterIdsWithBotIds
} from '../../helpers/multiCharacter';

/**
 * Renders every character of a multi-character simulation. Unlike
 * CharactersContainer, where only the selected character gets the client,
 * each avatar here gets its own view of it: it talks only while its bot's
 * audio plays and keeps its own emotion.
 *
 * Every avatar also runs the custom animation in place of the looping
 * avaturn_animation clip, so a row of them breathes and blinks out of step
 * rather than in lockstep.
 */
function MultiCharactersContainer({ client, talkingBotId, emotionsByBotId }) {
  const { characterIds, botIds } = useSimulationContext();

  const characters = useMemo(
    () => pairCharacterIdsWithBotIds(characterIds, botIds),
    [characterIds, botIds]
  );

  if (!client) return null;

  return (
    <>
      {characters.map(({ characterId, botId }, index) => (
        <group
          key={botId ?? `${characterId}-${index}`}
          frustumCulled
          position={getMultiCharacterPosition(index, characters.length)}
        >
          <AvatarLoader
            characterId={characterId}
            enableCustomAnimation
            client={buildCharacterClient({
              client,
              botId,
              talkingBotId,
              emotionsByBotId
            })}
          />
        </group>
      ))}
    </>
  );
}

export default MultiCharactersContainer;
